import React from "react";

function BillContainer({ networks = [],bridgeFee = 0, gasFee = 0 } ) {
  const selectedPickupNetWorkCurrency = () => {
    const selectedNetwork = networks.find((el) => el.isSelected);
    return selectedNetwork
      ? selectedNetwork && selectedNetwork.currency
      : "NON";
  };



  return (
    <div>
       <div className="flex my-1 justify-between">
        <p >Bridging time </p>
        <p>{`~3 -20 min`}</p>
      </div>
      <br></br>
      <div className="flex my-1 justify-between">
        <p>Network gas fee</p>
        <p>{`~${gasFee} ${selectedPickupNetWorkCurrency()}`}</p>
      </div>
      <div className="flex my-1 justify-between">
        <p>Bridge fee</p>
        <p> {`${bridgeFee} ${selectedPickupNetWorkCurrency()}`}</p>
      </div>
      <div className="border-b border-solid border-sunny-border dark:border-dark-border "></div>
      <div className="flex mt-3 justify-between">
        <p>Total fees</p>
        <p> {`${(Number(bridgeFee) + Number(gasFee)).toFixed(5)} ${selectedPickupNetWorkCurrency()}`}</p>
      </div>
    </div>
  );
}

export default BillContainer;
